import { z } from "zod";

const participantSchema = z.object({
  entityId: z.string(),
  participantId: z.string(),
  name: z.string(),
});

const breakoutSessionSchema = z.object({
  name: z.string(),
  participants: z.array(participantSchema).min(1, {
    message: "At least one participant is required",
  }),
});

const createBreakoutSessionsSchema = z.object({
  breakoutSessions: z.array(breakoutSessionSchema).min(1, {
    message: "At least one breakout session is required",
  }),
  timer: z.preprocess(
    (val) => (val === "" || val === undefined ? undefined : Number(val)),
    z
      .number()
      .min(1, {
        message: "Timer must be at least 1 minute",
      })
      .optional(),
  ),
});

const updateBreakoutSessionSchema = z.object({
  participants: z.array(participantSchema),
});

type CreateBreakoutSessionsFormData = z.infer<
  typeof createBreakoutSessionsSchema
>;

type UpdateBreakoutSessionFormData = z.infer<
  typeof updateBreakoutSessionSchema
>;

type ParticipantOptionData = z.infer<typeof participantSchema>;

export { createBreakoutSessionsSchema, updateBreakoutSessionSchema };
export type {
  CreateBreakoutSessionsFormData,
  ParticipantOptionData,
  UpdateBreakoutSessionFormData,
};
